import React from 'react';
import './Sectionbureau.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowRight } from 'react-icons/fi';

const mediaVariants = {
  rest: { y: 0, boxShadow: '0 0px 0px rgba(43, 36, 32, 0)' },
  hover: { y: -6, boxShadow: '0 26px 44px -18px rgba(43, 36, 32, 0.45)' },
};

const imageVariants = {
  rest: { scale: 1 },
  hover: { scale: 1.07 },
};

const tagVariants = {
  rest: { rotate: -7, scale: 1 },
  hover: { rotate: 0, scale: 1.06 },
};

const ctaVariants = {
  rest: { x: 0 },
  hover: { x: 4 },
};

const Sectionbureau = (props) => {
  return (
    <motion.div
      className="hd-pcard-wrap mb-4"
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <Link className="hd-pcard-link" to={`/${props.nom}/details/${props.id}`}>
        <motion.div className="hd-pcard" initial="rest" whileHover="hover" animate="rest">
          <motion.div className="hd-pcard-media" variants={mediaVariants} transition={{ duration: 0.35, ease: 'easeOut' }}>
            <motion.img
              src={props.image}
              alt={props.titre}
              className="hd-pcard-image"
              variants={imageVariants}
              transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            />

            <motion.span
              className="hd-pcard-tag"
              variants={tagVariants}
              transition={{ type: 'spring', stiffness: 320, damping: 16 }}
            >
              {props.prix} DT
            </motion.span>
          </motion.div>

          <div className="hd-pcard-info">
            <h3 className="hd-pcard-title">{props.titre}</h3>

            <motion.span className="hd-pcard-link-text" variants={ctaVariants} transition={{ type: 'spring', stiffness: 380, damping: 20 }}>
              Découvrir
              <FiArrowRight />
            </motion.span>
          </div>
        </motion.div>
      </Link>
    </motion.div>
  );
};

export default Sectionbureau;
